export default __webpack_public_path__ + "static/comparisons-feature-engineering-935732eaa1d533a52dfb2c39c450a8de.png";